import React from 'react';
import PropTypes from 'prop-types';


var FormGroup = (props) => {

  const requiredStyle = props.isRequired ? "required":""

  return (
    <div className={`form-group ${requiredStyle}`}>
      {props.children}
    </div>
  )
}

FormGroup.propTypes = {
  label: PropTypes.string,
  inline: PropTypes.bool,
  isRequired: PropTypes.bool,
}

FormGroup.defaultProps = {
  inline: false,
  isRequired: false
}

var FormGroupHorizontal = (props) => {

  const requiredStyle = props.isRequired ? "required":""

  var labelColSize = props.labelWidth.map(value=>{
    return `col-${value.breakPoint}-${value.width}`
  })

  var colSize = props.width.map(value => {
    return `col-${value.breakPoint}-${value.width} `;
  })

  return (
    <div className={`form-group ${requiredStyle}`}>
      <label className={`${labelColSize.join(' ')} control-label`}>{props.label}</label>

      <div className={colSize.join(' ')}>
        {props.children}
      </div>

    </div>
  )
}

FormGroupHorizontal.propTypes = {
  label: PropTypes.string.isRequired,
  labelWidth: PropTypes.arrayOf(PropTypes.shape({
    breakPoint: PropTypes.string,
    width: PropTypes.number
  })),
  width: PropTypes.arrayOf(PropTypes.shape({
    breakPoint: PropTypes.string,
    width: PropTypes.number
  })),
  isRequired: PropTypes.bool,
}

FormGroupHorizontal.defaultProps = {
  isRequired: false
}

export { FormGroup, FormGroupHorizontal }
export default FormGroup
